module.exports = __webpack_public_path__ + "img/1.692a28a8.png";